/* 🤖 this file was generated by svg-to-ts */
export const rpgAwesomeIconBottomRight: {
  name: 'bottom_right';
  data: string;
} = {
  name: 'bottom_right',
  data: `<svg xmlns="http://www.w3.org/2000/svg" xml:space="preserve" x="0" y="0" version="1.1" viewBox="0 0 613 613"><path d="M601.225 598.409 550.963 175.37l-73.997 73.997L189.355 10.622H13.438v182.199L249.39 476.943l-71.205 71.205 423.04 50.261zM21.96 67.28l.36-45.815h128.454l319.108 267.287 64.04-64.04L566.19 506.82l-282.109-32.268 61.409-61.409L21.96 67.28z"/></svg>`,
};
